import React from 'react'


import arrowLeft from '../../assets/preisrechner/svg/arrow-left.svg'
import arrowRight from '../../assets/preisrechner/svg/arrow-right.svg'

const NavigationButtons = props => {
    return (
      <div className={ (props.pageNumber == 0 || props.pageNumber == props.finalPage) ? "vermNav hide" : "vermNav" }>
          <div className="rightButtonContainer previousButton">
          { (props.pageNumber > 0) && 
            <a className="nextButton" onClick={props.back}>
              <span className="nextButtonInner">
                <span className="nextButtonText">
                  <img width="10px" src={arrowLeft}/>
                  zurück
                </span>
              </span>
            </a>
          }
          </div>
          <div className="rightButtonContainer">
            <a className="nextButton" onClick={ (props.pageNumber == props.finalPage-1) ? props.finalSubmit : props.next}>
              <span className="nextButtonInner">
                <span className="nextButtonText">
                  <img width="10px" src={arrowRight}/>
                  { (props.pageNumber == props.finalPage-1) ? props.finalText :'weiter'}
                </span>
              </span>
            </a>
          </div>
        </div>
    );
}

export default NavigationButtons